import { FormControl, FormGroup, Validators } from '@angular/forms';

export class ExemptVendorTypeForm extends FormGroup<{
  id: FormControl<undefined | number>;
  type: FormControl<undefined | string>;
  isTaxIdRequired: FormControl<undefined | boolean>;
  CompanyId: FormControl<undefined | number>;
  createdAt: FormControl<undefined | Date>;
  updatedAt: FormControl<undefined | Date>;
}> {
  constructor() {
    super({
      id: new FormControl<undefined | number>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      type: new FormControl<undefined | string>(undefined, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      isTaxIdRequired: new FormControl<undefined | boolean>(undefined, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      CompanyId: new FormControl<undefined | number>(undefined, {
        nonNullable: true
      }),
      createdAt: new FormControl<undefined | Date>(undefined, {
        nonNullable: true
      }),
      updatedAt: new FormControl<undefined | Date>(undefined, {
        nonNullable: true
      })
    });
  }
}
